import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas, faPenToSquare, faRotate, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';

function ProductCategory() {
  const [data, setData] = useState(false);
  const [data1, setData1] = useState(false);
  const [pageData, setPageData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(0);
  const [editData, setEditData] = useState(false);
  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <IconField iconPosition="right">
        <InputIcon className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </IconField>
    </div>
  );
  const handleClose = () => {
    setShowModal(false);
    setEditData(false);
  };
  const editCategory = (index) => {
    setEditIndex(index);
    setEditData(true);
  };
  const changeData = async (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setData1({ ...data1, data: { ...data1.data, [editIndex]: { ...data1.data[editIndex], [name]: value } } });
  };
  const deleteCategory = async (id) => {
    try {
      const response = await axios.post('/product/deleteProductCategory', { id });
      const { status, message } = response.data;
      if (status) {
        setRefresh(!refresh);
        toast(message);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { categoryName } = e.target;
      const response = await axios.post('/product/addProductCategory', { categoryName: categoryName.value });
      const { status, message } = response.data;
      if (status) {
        setRefresh(!refresh);
        setShowModal(false);
      }
      else {
        setShowModal(false);
      }
      toast(message);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const updateSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        jsonData[item.name] = item.value;
      }
    });
    try {
      const response = await axios.post('/product/updateProductCategory', { ...jsonData, id: data1 && data1.data[editIndex]._id });
      const { status, message } = response.data;
      if (status) {
        setRefresh(!refresh);
        handleClose();
      }
      toast(message);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const fetchData = async (event) => {
    let rechargeData = {
      first: event.first,
      rows: event.rows,
    };
    getData(rechargeData);
  };

  const getData = async (requestData = {}) => {
    try {
      setLoading(true);
      const response = await axios.post("/history/getProductCategory", requestData);
      const { status, data, first, rows, totalRecords } = response.data;
      if (status) {
        setData(response.data);
        setData1(response.data);
        setPageData({ first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    getData();
  }, [refresh]);

  const ChangeStatus = async (options, e) => {
    options.editorCallback(e.target.value)
    try {
      const response = await axios.post('/product/changeProductCategoryStatus', { id: options.rowData._id, status: e.target.value });
      const { status, message } = response.data;
      if (status) {
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const onCellEditComplete = (e) => {
    let { rowData, newValue, field, originalEvent: event } = e;
    if (newValue.trim().length > 0) rowData[field] = newValue;
    else event.preventDefault();
  };

  const cellEditor = (options) => {
    return (
      <select value={options.value} onChange={(e) => ChangeStatus(options, e)} onKeyDown={(e) => e.stopPropagation()}>
        <option value="1">Active</option>
        <option value="0">InActive</option>
      </select>
    );
  };

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                Product Category
                {/* Button that triggers the modal */}
                <Button className="float-right" variant="primary" onClick={(e) => setShowModal(true)}>
                  Add
                </Button>
              </h4>
            </div>
          </div>
        </div>
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                data && (
                  <>
                    <h4 class="card-title">
                      Product Category
                    </h4>
                    <DataTable
                      value={data.data}
                      size="small"
                      editMode="cell"
                      globalFilter={globalFilter}
                      header={header}
                      className="custom-table" // Add custom class here
                      loading={loading}
                    >
                      <Column
                        field="index"
                        header="#"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                      />
                      <Column
                        field="created_at"
                        header="Date"
                        sortable
                        body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                      />
                      <Column
                        field="categoryName"
                        header="CategoryName"
                        sortable
                        body={(rowData) => <span data-label="CategoryName">{rowData?.categoryName}</span>}
                      />
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        body={(rowData) => <span data-label="Status">{rowData?.status == "1" ? "Active" : "InActive"}</span>}
                        editor={(options) => cellEditor(options)}
                        onCellEditComplete={onCellEditComplete}
                      />
                      <Column
                        field="action"
                        header="Action"
                        sortable
                        body={
                          (rowData, { rowIndex }) => (
                            <span data-label="Action">
                              <Link onClick={(e) => editCategory(rowIndex)}><FontAwesomeIcon icon={faPenToSquare} className="successIcon" title="Edit" /></Link>
                              <Link onClick={(e) => deleteCategory(rowData?._id)}><FontAwesomeIcon icon={fas.faTrash} className="successIcon" title="Delete" /></Link>
                            </span>
                          )
                        }
                      />
                    </DataTable>
                    <div className="card">
                      <Paginator first={pageData && pageData.first} rows={pageData && pageData.rows} totalRecords={pageData && pageData.totalRecords} rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]} onPageChange={fetchData} />
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      {/* Modal component */}
      <Modal show={showModal} onHide={handleClose} centered backdrop="static">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="row justify-content-center">
              <div class="col-md-12">
                <div className="row">
                  <div class="col-lg-12 col-md-12">
                    <label>Category Name</label>
                    <input className="form-control" name="categoryName" required />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              Add
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal show={editData} onHide={handleClose} centered backdrop="static">
        <Form onSubmit={updateSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Update Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    <label>Category Name</label>
                    <input className="form-control" type="text" name="categoryName" value={data1?.data?.[editIndex]?.categoryName} onChange={changeData} />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              Update
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default ProductCategory;
